module.exports = __webpack_public_path__ + "img/gigwidog3.42ab534f.jpg";